import React from "react";
import { formatMoney } from "../utils/format";

export default function MetricCards({ dashboard, currency }) {
  const { metrics, statuses } = dashboard;
  const cards = [
    { className: "card-total", icon: "📋", label: "Total Jobs Registered", value: metrics.total },
    { className: "card-pending", icon: "⏳", label: "Pending Approval", value: statuses.pending.count },
    { className: "card-progress", icon: "⚙️", label: "In Production", value: statuses.in_progress.count },
    { className: "card-completed", icon: "✅", label: "Completed / Delivered", value: statuses.completed.count },
    { className: "card-revenue", icon: "💰", label: "Total Register Value", value: formatMoney(metrics.total_value, currency) },
    { className: "card-balance", icon: "💳", label: "Outstanding Balance", value: formatMoney(metrics.outstanding, currency) },
  ];

  return (
    <section className="metrics-grid">
      {cards.map((card) => (
        <div key={card.className} className={`metric-card ${card.className}`}>
          <div className="metric-icon">{card.icon}</div>
          <div className="metric-info">
            <span className="metric-label">{card.label}</span>
            <span className="metric-value">{card.value}</span>
          </div>
        </div>
      ))}
    </section>
  );
}
